module.exports = __webpack_public_path__ + "dec845c80873c3cdcbde65df66792060.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/dianli_h.png
// module id = 271
// module chunks = 3